.card {
  display: grid;
  align-content: start;
  gap: 8px;
  min-width: 0;
  padding: 12px 14px;
}

.head {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.title {
  color: var(--ink);
  font-size: var(--t-dense);
  font-weight: 650;
}

/* The unit, as written, muted, at the right of the title row. Never upper-cased. */
.unit {
  margin-left: auto;
  color: var(--muted);
  font-size: var(--t-min);
  text-transform: none;
}

.toggle {
  padding: 1px 8px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-pill);
  background: none;
  color: var(--ink-2);
  font: inherit;
  font-size: var(--t-min);
  cursor: pointer;
}

.toggle:hover {
  background: var(--panel-2);
}

.toggle[aria-pressed="true"] {
  border-color: var(--ink-2);
  background: var(--panel-3);
  color: var(--ink);
}

.toggle:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.action {
  font-size: var(--t-min);
}
